import axios from "axios";
import { IDM_SERVER_BASE_URL } from "../Constants";

export const API_URL = IDM_SERVER_BASE_URL + "/v2/api";
export const USER_NAME_SESSION_ATTRIBUTE_NAME = "authenticatedUser";
export const COOKIES = "COOKIES";
export const SEPERATOR = "----";

class AuthenticationService {
    Authenticate(loginUserDTO) {
        var responsePromise = axios.post(`${API_URL}/Authenticate`, loginUserDTO, {
            headers: {
                "Content-Type": "application/json",
            },
        }, { withCredentials: true });

        var cookies = responsePromise.then((response) => {
            var cookies = response.headers["set-cookie"];
            var c = response.config.headers;
        });

        return responsePromise;
    }

    SelectTenant(selectTenantDTO) {
        var responsePromise = axios.post(`${API_URL}/SelectTenant`, selectTenantDTO, {
            headers: {
                "Content-Type": "application/json",
            },
        }, { withCredentials: true });

    return responsePromise;
    }

    GetTenants = async () => {
        const response = await axios.get(`${API_URL}/GetTenants`, {
            headers: {
                "Content-Type": "application/json",
            },
        }, { withCredentials: true });
        return response.data;
    };

  registerSuccessfulLoginForJwt(username, token, cookies) {
    sessionStorage.setItem(USER_NAME_SESSION_ATTRIBUTE_NAME, username);
    this.setupAxiosInterceptors(this.createJWTToken(token));
    if (Array.isArray(cookies)) {
      this.setupAxiosCookies(cookies);
      // var cookieString = "";
      // cookies.forEach(x => {
      //     cookieString += x + SEPERATOR
      // })
      // sessionStorage.setItem(COOKIES, cookieString);
    }
  }

    createJWTToken(token) {
        return "Bearer " + token;
    }

    logout() {
        const response = axios.post(`${API_URL}/Logout`, { withCredentials: true });
        sessionStorage.removeItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
        sessionStorage.removeItem(COOKIES);
        this.setupAxiosInterceptors(this.createJWTToken(""));
        this.setupAxiosCookies([]);
        return response;
    }

    isUserLoggedIn() {
        let user = sessionStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
        if (user === null) return false;
        return true;
    }

    getLoggedInUserName() {
        let user = sessionStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
        if (user === null) return "";
        return user;
    }

    setupAxiosInterceptors(token) {
        axios.interceptors.request.use((config) => {
            if (this.isUserLoggedIn()) {
                config.headers.authorization = token;
            }
            return config;
        });
    }

    setupAxiosCookies(cookies) {
        axios.interceptors.request.use((config) => {
            config.headers.cookies = cookies;
            return config;
        });
    }
}

export default new AuthenticationService();
